import { addNavMenuItem, addNavMenuSection } from "@bb-vendure/admin-ui/core";

export default [
  addNavMenuItem(
    {
      id: "need-to-ship-list",
      label: "nav.need-to-ship",
      routerLink: ["/extensions/need-to-ship"],
      icon: "truck",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadNeedToShip");
      },
    },
    "process"
  ),
];
